import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import { TXTWCL_The_offer_is_only_valid_for_pe_ELL } from './RegulatoryHeaderDESH.messages.json';
import styles from './RegulatoryHeaderDESH.scss';

const RegulatoryHeaderDESH: React.FC = () => (
  <div className={styles.regulatoryHeader}>
    <Translation {...TXTWCL_The_offer_is_only_valid_for_pe_ELL} />
  </div>
);

export default RegulatoryHeaderDESH;
